export default __webpack_public_path__ + "static/media/Taskmo-Leadership-Photos.92798534.zip";